<template>
  <div>
    <v-card>
      <img ref="barcode"/>
      <v-card-text>
        <v-text-field v-model="value" :readonly="readonly" />
        <v-alert v-model="verify.dialog" color="error" icon="priority_high">
          {{verify.error}}
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>

</style>

<script>
import BarcodeInput from "./barcodeInput.ts";
export default BarcodeInput;
</script>